let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("eiB8M"), load("aD9MA")]).then(() => parcelRequire('dKz3J'));